import { handleChange } from "../logic";
var useHandleChange = function useHandleChange(checkedItems, setCheckedItems) {
  return handleChange(checkedItems, setCheckedItems);
};
export default useHandleChange;